<template>
  <section class="text-center my-10">
    <span class="grey--text">Designed and made with ⚡ Janis Rozenfelds</span>
    <div class="d-flex justify-center my-2">
      <template v-for="(item, index) in navigation">
        <button-link :key="index" :title="item.title" :url="item.url" class="mx-4 font-weight-light text--red" />
      </template>
    </div>
    <span class="caption grey--text">© 2021 User Profile</span>
  </section>
</template>
<script>
export default {
  data: () => ({
    navigation: [
      {title: 'Support', url: 'https://userprofile.nolt.io'},
      {title: 'About', url: '/user-profile-plugin/about'},
      {title: 'How to use', url: '/user-profile-plugin/how-to-use'},
      {title: 'License', url: 'https://unsplash.com/license'},
    ],
  }),
}
</script>
